export const LMS_USER: string = "LMS_USER";
export const LMS_LOGOUT_INFO: string = "LMS_LOGOUT_INFO";
export const LMS_PAGE_LOGOUT_RELOAD: string = "LMS_PAGE_LOGOUT_RELOAD";